(function ($) {

  $signaturePopupContainer = $('.signature-popup');
  $signaturePopup = $signaturePopupContainer.find('.inner');
  $registrants = $signaturePopup.find('.registrants');
  $isSignaturePopupOpened = false;
  $signaturePopupForm = $('.shopify-product-form');
  $qtyInput = null;
  $signatureTimestamp = null;
  $currentProductID = null;
  
  /*
   * Close Event
   */
  $signaturePopup.find('.close-popup').click( function (event) {

    event.preventDefault();

    // We trigger the closing event.
    $signaturePopupContainer.trigger('popup.close')

  });


  $signaturePopupContainer.click( function () {
  	$(this).trigger('popup.close');
  });


  $signaturePopup.click( function( event ) {
  	event.stopPropagation();
  });

  $signaturePopup.on('change', 'input', function (event) {
        $(this).siblings('.signature-validation').remove();
  });


  /**
   * Popup submit event
   */
  $signaturePopup.find('button.confirm').click( function (event) {
  	event.preventDefault();
    $signaturePopupForm.find('button.button--add-to-cart').click();
  });



  /*
   * Open Event
   */
  $signaturePopupContainer.on('popup.open', function( event, qty ) {

    $isSignaturePopupOpened = true;
    $registrants.empty();


    for ($i = 1; $i <= qty; $i++) {
      var registrant = buildRegistrant( $i );
      $registrants.append( registrant );
    }

    $(this).fadeIn();
  });


  $signaturePopupContainer.on('popup.close', function() {
    $isSignaturePopupOpened = false;
  	$(this).fadeOut();


    if ($qtyInput) {
    	$qtyInput.val( $qtyInput.data('quantity-old') );
      	$qtyInput = null;
    }

    setTimeout( function () {
        $registrants.empty();
    }, 500 );
  });



  $signaturePopupContainer.on('cart.popup.open', function( event, qty, existing, input ) {


    $isSignaturePopupOpened = true;
	$registrants.empty();
    $qtyInput = input;

    for ($i = 0; $i < qty; $i++) {
      var registrant = buildRegistrant( $i + 1 );

      if ( typeof existing[$i] !== 'undefined' ) {
      	registrant.find('input[name*=SignatureFirstName]').val( existing[$i].first_name );
        registrant.find('input[name*=SignatureLastName]').val( existing[$i].last_name );
      	registrant.find('input[type=email]').val( existing[$i].email );
      }

      $registrants.append( registrant );
    }

    $(this).fadeIn();

  });

  $(document).on('click', '.product-form button.open-register-button',  function (event) {

      console.log('apples?');
    
      var $form = $(this).closest('form');

      // If the signature is required but the popup is not opened,
      // we just open the popup and return false. Otherwise we skip it.
      console.log($form.data('require-signature'));
      console.log(window.signatureForm( $form.data('product-id'), $form));
    
      if ( $form.data('require-signature') == true && !window.signatureForm( $form.data('product-id'), $form ) ) {
          event.preventDefault();
          return false;
      }

  });

  $('a.open-register-add-button').click(function (event) {
      const input = $(this).prev();
      input.val(parseInt(input.val())+1).change();
  });
  $('a.open-register-remove-button').click(function (event) {
      const input = $(this).next();
      input.val(parseInt(input.val())-1 || 0).change();
  });

  window.updateAndShowCart = function ($this) {
      var $form = $this.closest('.cart__item').addClass('openForm');
      window.triggerSignatureForm($this);
  };

  /**
   * Builds the needed html to create a slot within the popup
   */
  function buildRegistrant(i) {

    var response = '<fieldset><legend>Registrant #' + i + '</legend>';

    response += '<div class="half"><label>First Name</label><input type="text" name="properties[SignatureFirstName' + i + ']"></div>';
    response += '<div class="half"><label>Last Name</label><input type="text" name="properties[SignatureLastName' + i + ']"></div>';
    response += '<div><label>Email</label><input type="email" name="properties[Email' + i + ']"></div>';
    response += '</fieldset>';

    return $(response);
  }

  window.signatureForm = function (product_id, $productForm) {

      $currentProductID = product_id;

      if ( $signatureTimestamp == null ) {
          $signatureTimestamp = Date.now();
      } else {
          if ( (Date.now() - $signatureTimestamp) < 1000 ) return false;
      }

      $signatureTimestamp = Date.now();

      var quantity =  $productForm.find('input[name=quantity]').val() || 1;

      // Let's get the current popup.
      var $current = $signaturePopupContainer.filter( function () {
          return $(this).data('product-id') == product_id;
      });

      // If the quantity is greater than 1, we open the popup and
      // stop the current behavior.
      if ( !$isSignaturePopupOpened ) {
            $signaturePopupForm = $productForm;
            $current.trigger('popup.open', [ quantity ]);
            return false;
      }

      // Validations.
      // The first step is to remove any signature validation we find.
      $('.signature-validation').remove();

      var valid = validateInputs();

      if ( valid ) {
          $current.trigger('popup.close');

          var dupCode = Date.now();
          if ( $productForm.find('.prevent_duplicates').length > 0 ) {
                $productForm.find('.prevent_duplicates').val( dupCode );
          } else {
                $productForm.append('<input type="hidden" name="properties[_duplicates_code]" value="' + dupCode + '">');
          }
      }

      // We return false if the form is not valid.
      return valid;
  }

}(jQuery));


function validateInputs() {

    var valid = true;

    // Let's get the current popup.
    var $current = $signaturePopupContainer.filter( function () {
                        return $(this).data('product-id') == $currentProductID;
                   });

    if ( $isSignaturePopupOpened ) {

      var $cart = {};
      var $emailsList = [];

      // Syncronously getting the cart.
      $.ajax({
          url: '/cart.js',
          method: 'GET',
          dataType: 'json',
          async: false,
          success: function( cart ) {
              $cart = cart;
          }
      });


      $current.find('input').each( function (k, v) {

        var $input = $(this);

        if ($input.val() == '') {
          $input.after('<p class="signature-validation">This field cannot be left blank.</p>');
          valid = false;
          return true;
        }

        if ($input.val() != '' && $input.attr('type') == 'email' && !isValidEmail( $input.val() )) {
          $input.after('<p class="signature-validation">This field must be a valid email address</p>');
          valid = false;
          return true;
        }

        if ( $input.attr('type') == 'email') {
            var $email = $input.val();
            if ( $emailsList.indexOf( $email ) > -1 ) {
                $input.after('<p class="signature-validation">This email address is already used</p>');
                valid = false;
                return true;
            }

            $emailsList.push( $email );

            $( $cart.items ).each( function (j, l) {

               if ( l.product_id != $currentProductID ) return true;

               var regex = /Email(\d+)/g;
               for ( var key in l.properties ) {
                    if ( regex.exec( key ) ) {
                        if ( l.properties[key] == $email ) {
                            $input.after('<p class="signature-validation">This email address is already used in another item added to cart.</p>');
                            valid = false;
                            return false;
                        }
                    }
               }
            });
        }
      });

      return valid;
    }
}

function isValidEmail( address ) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(address);
}
